<input #fileInput type="file" accept="image/*" class="file-input-hidden" (change)="onFileSelected($event)" />

@if (quotedMessage()) {
  <div class="quoted-preview or-px-12-px or-pt-8-px">
    <div class="quoted-preview-content">
      <div class="quoted-preview-bar"></div>
      <div class="quoted-preview-text">
        <div class="quoted-preview-user or-note-sm">Odpowiedź dla {{ quotedMessage()!.userName }}</div>
        @if (quotedMessage()!.text) {
          <div class="quoted-preview-message or-text-sm">{{ quotedMessage()!.text }}</div>
        } @else if (quotedMessage()!.imageUrl) {
          <div class="quoted-preview-message or-text-sm">📷 Zdjęcie</div>
        }
      </div>
      <button class="quoted-preview-close" (click)="cancelQuote()">
        <ion-icon name="close" class="close-icon"></ion-icon>
      </button>
    </div>
  </div>
}
@if (isEditing()) {
  <div class="editing-preview or-px-12-px or-pt-8-px">
    <div class="editing-preview-content">
      <ion-icon name="create-outline" class="editing-icon"></ion-icon>
      <div class="editing-preview-text or-text-sm">Edytowanie wiadomości</div>
      <button class="editing-preview-close" (click)="cancelEdit()">
        <ion-icon name="close" class="close-icon"></ion-icon>
      </button>
    </div>
  </div>
}
@if (imagePreview()) {
  <div class="image-preview-container or-px-12-px or-pt-8-px">
    <div class="image-preview-wrapper">
      <img [src]="imagePreview()" alt="Preview" class="image-preview" />
      <button class="remove-image-btn" (click)="removeSelectedImage()">
        <ion-icon name="close-circle" class="remove-icon"></ion-icon>
      </button>
    </div>
  </div>
}

<div class="input-container or-d-flex or-align-items-end or-px-12-px or-py-8-px or-bg-white">
  @if (!isEditing()) {
    <button class="attachment-button or-mr-8-px" (click)="openFilePicker()">
      <ion-icon name="image-outline" class="attachment-icon"></ion-icon>
    </button>
  }

  <div class="input-wrapper or-flex-1 or-d-flex or-align-items-end" style="position: relative">
    @if (showMentionAutocomplete()) {
      <lib-mention-autocomplete
        [members]="channelMembers"
        [filterText]="mentionFilterText()"
        (memberSelected)="onMentionSelected($event)">
      </lib-mention-autocomplete>
    }
    <textarea
      #messageInput
      class="message-textarea"
      [ngModel]="messageText()"
      (ngModelChange)="messageText.set($event)"
      (keydown)="onKeydown($event)"
      (input)="onInput()"
      [placeholder]="isEditing() ? 'Edytuj wiadomość...' : 'Napisz wiadomość...'"
      rows="1">
    </textarea>
  </div>

  <button
    class="send-button or-ml-8-px"
    [class.send-button-active]="canSend()"
    [class.send-button-edit]="isEditing() && canSend()"
    [disabled]="!canSend()"
    (click)="sendMessage()">
    <ion-icon [name]="isEditing() ? 'checkmark' : 'send'" class="send-icon"></ion-icon>
  </button>
</div>
